

export const getAllPlacementAudits = state => state.placementAudits.items;
